<p>
  Demo translate:
</p>
<!-- <p>{{ 'welcomeMessage' | translate: user }}</p> -->

<div *ngIf="finishedLoadingTranslation">


  <input type="password"
         placeholder="{{ 'login.password' | translate }}">

</div>
